var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('button',{attrs:{"id":"mediaLibrary"}},[_vm._v(" open ML ")])])}
var staticRenderFns = []

export { render, staticRenderFns }